module.exports = __webpack_public_path__ + "static/speedrank-hero-d99500c2f1f021e4f0c0e1ba3f6756fe.png";